import React from 'react';
import styles from './DateRangeFilter.module.css';
import { DateRangeFilterProps } from './types';

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({ dateFrom, dateTo, onChange }) => {
  const setPreset = (days: number) => {
    const to = new Date();
    const from = new Date();
    from.setDate(to.getDate() - days);
    const iso = (d: Date) => d.toISOString().slice(0, 10);
    onChange({ dateFrom: iso(from), dateTo: iso(to) });
  };
  return (
    <div className={styles.filter}>
      <button type="button" className={styles.preset} onClick={() => setPreset(7)}>Last 7 days</button>
      <button type="button" className={styles.preset} onClick={() => setPreset(30)}>Last 30 days</button>
      <input type="date" className={styles.date} value={dateFrom} onChange={(e) => onChange({ dateFrom: e.target.value, dateTo })} />
      <span className={styles.sep}>→</span>
      <input type="date" className={styles.date} value={dateTo} onChange={(e) => onChange({ dateFrom, dateTo: e.target.value })} />
    </div>
  );
};

export default DateRangeFilter;
